'use client';
import React, { useEffect, useState } from 'react';
import whatsapp from '../../public/svg/whatsapp.svg';
import Image from 'next/image';
import Link from 'next/link';

const FloatingBar = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const isVisibleFromTop = scrollY > 600;
      const isCloseToBottom =
        window.innerHeight + scrollY >= document.body.offsetHeight - 700;
      setIsVisible(isVisibleFromTop && !isCloseToBottom);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className='relative'>
      <div
        className={`${
          isVisible ? 'opacity-100' : 'opacity-0'
        } fixed bottom-5 left-10 transition-opacity`}
      >
        <div className=' hidden rounded-[16px] bg-gradient-to-r from-[#222539] to-[#284565] px-5 pt-5 lg:block lg:h-[118px] lg:w-[166px] 2xl:h-[158px] 2xl:w-[222px] '>
          <p className='text-center font-[600] text-white lg:text-[10px] 2xl:text-[14px]'>
            The Surgery You Need is Just a Click Away
          </p>
          <Link
            href={`https://wa.me/${process.env.NEXT_PUBLIC_WHATSAPP_AI_AGENT_NUMBER}?text=Hi, I'm interested in booking a surgery consultation. Can you help me schedule an appointment?`}
            target='_blank'
            rel='noopener noreferrer'
            className='flex items-center justify-center rounded-[10px] bg-[#17DFBA] font-[500] text-white transition-colors hover:bg-[#16C8A8] lg:mx-2 lg:mt-3 lg:h-[27px] lg:w-[112px] lg:text-[13px] 2xl:mx-5 2xl:mt-5 2xl:h-[36px] 2xl:w-[149px] 2xl:text-[18px]'
          >
            Book Now
          </Link>
        </div>
      </div>
      <Link
        href={`https://wa.me/${process.env.NEXT_PUBLIC_WHATSAPP_AI_AGENT_NUMBER}?text=Hey,%20tell%20me%20more%20about%20Karetrip's%20services`}
        className='fixed bottom-[100px] right-3 z-50 lg:hidden '
      >
        <Image width={52} height={52} alt='whatsapp' src={whatsapp} />
      </Link>
    </div>
  );
};

export default FloatingBar;
